'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {ReportsIndexCtrl} from "./reportsindexctrl.js";
EwSiteApp.controller('ReportsIndexCtrl', ["$scope", "jsDataService", ReportsIndexCtrl]);

import {ReportPreviewCtrl} from "./reportpreviewctrl.js";
EwSiteApp.controller('ReportPreviewCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", ReportPreviewCtrl]);